<template>
  <!-- 콘텐츠 -->
  <div id="container" class="error_container">
    <div class="error_wrap" style="text-align: center">
      <div class="bx_error">
        <span class="ico_error"></span>
        <p>
          <strong
            >서비스가 정상적으로 처리되지 않았습니다.<br />이용에 불편을 드려
            죄송합니다.</strong
          >
        </p>
        <p class="txt_tip">
          <span
            >문의사항은
            <em>인터넷 상담</em>
            또는
            <em>고객 콜센터(1566-7711)</em>를 이용해 주시기 바랍니다.</span
          >
        </p>
      </div>
      <div class="btn_area">
        <a href="/" class="btn btn_g01"
          ><span style="color: #fff">메인화면으로 이동</span></a
        >
      </div>
    </div>
  </div>
  <!--// 콘텐츠 -->
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

import Datepicker from "vue3-datepicker";
import { ko } from "date-fns/locale";

const swalAlert = inject("swalAlert");
const axios = inject("axios");
const state = reactive({
  logid: "",
  bizNo: "",
  txtGita: "",
  userInfo: {},
  currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),
  mstr_id_yn: "",
});

onMounted(async () => {});
</script>
